export default "__VITE_ASSET__CWMiqsEH__"